import script from "./ResponsePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsePage.vue?vue&type=script&setup=true&lang=js"

import "./ResponsePage.vue?vue&type=style&index=0&id=d90d66d0&lang=css"

const __exports__ = script;

export default __exports__